import { Text } from "../../../components/text/text";
import { useEffect, useState } from "react"
import { CalendarIcon, ClockIcon } from "../../../assets/icons"
import { Calendar } from "../../../components/calendar/calendar"
import { useSelector } from "react-redux"
import { usePopup } from "../../../components/popup/popup"
import { WeekDayPopup } from "./weekDayPopup"
import TableAPI from "../../../api/TableAPI"
import classNames from "classnames"

import styles from "./tablePage.module.css"

const months = ["январе", "феврале", "марте", "апреле", "мае", "июне", "июле", "августе", "сентябре", "октябре", "ноябре", "декабре"]

export const TablePage = () => {
    const [shifts, setShifts] = useState([]);
    const [total, setTotal] = useState({ shifts: 0, hours: 0 });
    const [date, setDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));

    const cafeId = useSelector(state => state.user.userData?.cafeId);

    const [Popup, open, close] = usePopup();
    const [popupParams, setPopupParams] = useState({date: new Date(), curShift: null});

    const onOpen = (date, curShift) => {
        if (!curShift) return;
        setPopupParams({date, curShift});
        open();
    }

    useEffect(() => {
        if (!cafeId) return;

        TableAPI
            .fetchTotalShifts(date.getFullYear(), date.getMonth() + 1)
            .then(res => setTotal(res))
            .catch(console.error);

        TableAPI
            .fetchShifts(cafeId, date.getFullYear(), date.getMonth() + 1)
            .then(res => setShifts(res))
            .catch(console.error);
    }, [date, cafeId]);

    return (
        <>
            <div className="page_header">
                <Text as="h1" variant="h3" className="page_title" >Табель</Text>
                <div className={styles.brief_info}>
                    <div className={styles.brief_info_item}>
                        <CalendarIcon className={styles.brief_item_icon} />
                        <Text as="div" variant="body" className={styles.brief_item_text} >Смен в {months[date.getMonth()]}: {total.shifts}</Text>
                    </div>
                    <div className={styles.brief_info_item}>
                        <ClockIcon className={styles.brief_item_icon} />
                        <Text as="div" variant="body" className={styles.brief_item_text} >Часов в {months[date.getMonth()]}: {total.hours.toFixed(0)}</Text>
                    </div>
                </div>
            </div>

            <Calendar date={date} setDate={setDate} shifts={shifts} onClick={onOpen} shiftType={shift => !!shift ? "shift" : "primary"} />

            <div className={styles.explanation_container}>
                <div className={classNames(styles.explanation_item, styles.shift)}>Рабочие смены</div>
            </div>

            <Popup>
                <WeekDayPopup date={popupParams.date} shift={popupParams.curShift} onClose={close} />
            </Popup>
        </>
    )
}